import { ArrayBase } from '../ArrayBase';

export class ContextualTargeting extends ArrayBase {}
